/**
 * Pure countdown helpers for the inactivity warning dialog. Shared by the ICS
 * `SessionStore` and the OHAH portal store so both show the same wording and
 * the same progress-bar maths.
 */

/** "4 minutes 5 seconds" / "1 minute 1 second" / "30 seconds"; '' once the time has passed. */
export function formatCountdown(logoutTime: number | null, now: number = Date.now()): string {
  if (!logoutTime) return '';

  const seconds = Math.floor(Math.max(0, logoutTime - now) / 1000);
  if (seconds <= 0) return '';

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  if (minutes > 0) {
    return `${minutes} minute${minutes !== 1 ? 's' : ''} ${remainingSeconds} second${remainingSeconds !== 1 ? 's' : ''}`;
  }
  return `${seconds} second${seconds !== 1 ? 's' : ''}`;
}

/** Fraction of the warning window remaining, 0-100. */
export function countdownPercent(
  logoutTime: number | null,
  warningWindowMs: number,
  now: number = Date.now(),
): number {
  if (!logoutTime) return 0;

  const remaining = Math.max(0, logoutTime - now);
  return Math.min(100, (remaining / warningWindowMs) * 100);
}
